<mat-list class="file-operation-list text-align-left" id="{{idPrefix}}">
  <mat-list-item *ngFor="let file of fileMetaList?.entries; let idx = index">

    <i *ngIf="withIconAvatars && file.status === fileStatus.READY"
       id="{{idPrefix}}item_{{idx}}.btn.show"
       matListIcon
       class="dr-fa-icon far {{file.fileType.faClass}} fa-lg"
       (click)="showFile(file)">
    </i>

    <i *ngIf="file.status === fileStatus.ERROR"
       matTooltip="{{ getErrorTitle(file) }}"
       matListIcon
       class="dr-fa-icon far {{ fileType.XLS.faClass }} fa-lg iq-color-warn-light">
    </i>

    <mat-spinner matListAvatar *ngIf="file.status === fileStatus.LOADING" [diameter]="18"></mat-spinner>

    <h3 matLine class="iq-link-style iq-color-white" [ngClass]="{ 'iq-color-warn-light': file.status === fileStatus.ERROR, 'file-loading': file.status === fileStatus.LOADING }" (click)="showFile(file)"> {{ file.filename }} </h3>

    <span class="info" *ngIf="labelProp">{{ file[labelProp] }}</span>

    <button id="{{idPrefix}}item_{{idx}}.btn.download"
            mat-icon-button
            *ngIf="canDownload"
            (click)="downloadFile(file)"
            [disabled]="disabled || file.status !== fileStatus.READY">
      <mat-icon class="dr-material-icon"
                [ngClass]="{ 'disabled': disabled || file.status !== fileStatus.READY }"
                matTooltip="{{ 'common.label.download' | translate }}">get_app
      </mat-icon>
    </button>
    <button id="{{idPrefix}}item_{{idx}}.btn.delete"
            mat-icon-button
            *ngIf="canDelete"
            (click)="deleteFile(file)"
            [disabled]="disabled || !hasDeletableStatus(file) || !canDeleteDynamically(file)">
      <mat-icon class="dr-material-icon"
                [ngClass]="{ 'disabled': disabled || !hasDeletableStatus(file) || !canDeleteDynamically(file) }"
                matTooltip="{{ 'common.label.delete' | translate }}">clear
      </mat-icon>
    </button>
  </mat-list-item>
</mat-list>
